import React, { useCallback, useState, useRef } from "react";
import MaterialReactTable from "material-react-table";
import { useDispatch } from "react-redux";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import { getListFacture } from "../../Redux/factureReduce";
import jwt_decode from "jwt-decode";
import { toast, ToastContainer } from "react-toastify";
import { useHistory } from "react-router-dom";
import { verification } from "../../Redux/usersReduce";
import { useTranslation } from 'react-multi-lang';
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import Configuration from "../../configuration";
import { useMemo } from "react";
function ListFacture({ client, obj }) {
  let lang = window.localStorage.getItem("lang");
  const t = useTranslation();
  const dispatch = useDispatch();
  const navigate = useHistory();
  var token = localStorage.getItem("x-access-token");
  var annee = localStorage.getItem("annee");
  var decoded = jwt_decode(token);
  var idUser = decoded.id;
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState(null);



  const idRole = useRef(0);

  const setIdRole = (newValue) => {
    idRole.current = newValue;
  };

  const columnsAfc = useMemo(() => [
    idRole.current !== 6
      ? {
        id: "code_grossiste",
        header: "Code " + t("Wholesaler"),
        accessorKey: "CodeClient",
      }
      : null,
    idRole.current !== 6
      ? {
        id: "grossiste",
        header: t("Wholesaler"),
        accessorKey: "Raison_sociale",
      }
      : null,
    {
      id: "No_facture",
      header: t("No_facture"),
      accessorKey: "NumFacture",
    },
    {
      id: "Date",
      header: t("Date"),
      accessorKey: "DateFacture",
    },
    {
      id: "Montant_HT_TND",
      header: t("Montant_HT_TND"),
      accessorKey: "MontantHT_TND",
      accessorFn: (row) =>
        new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(row.MontantHT_TND),
    },
    {
      id: "Montant_TTC_TND",
      header: t("Montant_TTC_TND"),
      accessorKey: "MontantTTC_TND",
      accessorFn: (row) =>
        new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(row.MontantTTC_TND),
    },
    {
      id: "telecharger",
      header: t("telecharger_pdf"),
      accessorKey: "",
      Cell: ({ cell }) => (
        <a
          className="btn btn-pdf"
          download={cell.row.original.NumFacture + 'TTN.pdf'}
          rel="noreferrer"
          href={Configuration.BACK_BASEURL + "facture/" + cell.row.original.NumFacture + 'TTN.pdf'}
          
        >
          <i className="fas fa-download"></i> {t("download")}
        </a>
      ),
    },
    {
      id: "details",
      header: t("details"),
      accessorKey: "id",
      Cell: ({ cell }) => (
        <Button
          id={"idLigne_" + cell.row.original.NumFacture}
          onClick={(e) => {
            detailsFacture(cell.row.original.NumFacture);
          }}
          className="btn-info btn "
          title={t("details")}
        >
          <i className="fa fa-eye" />
        </Button>
      ),
    },
  ], [client, t]);

  const [columns] = useState([
    {
      id: "No_facture",
      header: t("No_facture"),
      accessorKey: "NumFacture",
    },
    {
      id: "Date",
      header: t("Date"),
      accessorKey: "DateFacture",
    },
    {
      id: "Montant_HT_TND",
      header: t("Montant_HT_TND"),
      accessorKey: "MontantHT_TND",
      accessorFn: (row) =>
        new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(row.MontantHT_TND),
    },
    {
      id: "Montant_TTC_TND",
      header: t("Montant_TTC_TND"),
      accessorKey: "MontantTTC_TND",
      accessorFn: (row) =>
        new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(row.MontantTTC_TND),
    },
    {
      id: "telecharger",
      header: t("telecharger_pdf"),
      accessorKey: "",
      Cell: ({ cell }) => (
        <a
          className="btn btn-pdf"
          download={cell.row.original.NumFacture + 'TTN.pdf'}
          rel="noreferrer"
          href={Configuration.BACK_BASEURL + "facture/" + cell.row.original.NumFacture + 'TTN.pdf'}
          
        >
          <i className="fas fa-download"></i> {t("download")}
        </a>
      ),
    },
    {
      id: "details",
      header: t("details"),
      accessorKey: "id",
      Cell: ({ cell }) => (
        <Button
          id={"idLigne_" + cell.row.original.NumFacture}
          onClick={(e) => {
            detailsFacture(cell.row.original.NumFacture);
          }}
          className="btn-info btn "
          title={t("details")}
        >
          <i className="fa fa-eye" />
        </Button>
      ),
    },
  ]);

  function ListTable({ list, loader }) {
    return (
      <MaterialReactTable
        state={{ isLoading: loader }}
        columns={idRole.current == 6 ? columns : columnsAfc}
        data={list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={{ hover: false }}
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}
        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
        }}
        muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}

        filterFns={{
          myCustomFilterFn: (row, id, filterValue) => {
            const value = row.getValue(id);
            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
          },
        }}
        globalFilterFn="myCustomFilterFn"

        localization={
          lang === "fr"
            ? MRT_Localization_FR
            : MRT_Localization_EN
        }
      />
    );
  }
  const verifToken = useCallback(async () => {
    var response = await dispatch(verification());
    if (response.payload === false) {
      localStorage.clear();
      window.location.replace("/login");
    } else {
      setIdRole(response.payload.id_role)
    }
  }, [dispatch]);


  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }






  const fectchListFacture = useCallback(
    async (idUser, client) => {
      var etat = idRole.current == 5 ? [1] : [0];
      var list = await dispatch(
        getListFacture({
          id_user: idUser,
          etat, annee, client
        })
      );
      var res = list.payload.map(facture => ({
        ...facture,
        checked: false
      }));

      setLoader(false);
      setData(res);
    },
    [dispatch]
  );


  function detailsFacture(id) {
    navigate.push(client + "/detailsFacture/" + id);
  }


  React.useEffect(() => {
    const fetchData = async () => {
      await verifToken();
      if (idRole.current > 0) {
        fectchListFacture(idUser, client);
      }
    };

    fetchData();
  }, [idRole.current]);

  return (
    <>
      {alert}
      <Container fluid>
        <ToastContainer />

        <Row>

          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">{t("mes_facture")}</Card.Title>
                <br clear="all"></br>
              </Card.Header>
              <Card.Body className="table-style">
                <ListTable list={data} loader={loader} ></ListTable>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListFacture;
